import React, { useState, useRef, useEffect } from "react";
import PropTypes from "prop-types";
import { alpha } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import Checkbox from "@mui/material/Checkbox";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import DeleteIcon from "@mui/icons-material/Delete";
import FilterListIcon from "@mui/icons-material/FilterList";
import { visuallyHidden } from "@mui/utils";
import TextField from "@mui/material/TextField";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import { convertToUSFormat } from "../../../helpers/utils";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import PatientIdModal from "./PatientIdModal";
import ContactInfoForm from "./ContactInfoForm";
// import { useOutletContext } from 'react-router-dom';

import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";

import CloseIcon from "@mui/icons-material/Close";

import useHeaders from "../../../helpers/useHeaders";
import { useNavigate, useOutletContext, useParams } from "react-router-dom";
import useEncryption from "../../../services/useEncryption";
import {
  updateLeadStatusApi,
  getAllLeadsApi,
} from "../../../api/userApi/userApi";
import { toast } from "react-toastify";
import useToast from "../../../helpers/useToast";
import { getAgeCategory } from "../../../helpers/utils";
import { getTopSymptoms } from "../../../helpers/utils";
import AddNotesModal from "./AddNotesModal";
import Notes from "./Notes";
import {
  above13AgeQuestionsBVDQ,
  age4to8QuestionsBVDQ,
  age9to13QuestionsBVDQ,
  age4to8QuestionsHistory,
  above13AgeQuestionsHistory,
  age9to13QuestionsHistory,
  initialQuestionsData,
} from "../../../helpers/questions";
import { Calculate } from "@mui/icons-material";
import { useDispatch, useSelector } from "react-redux";
import {
  selectAuth,
  setSelectedId,
  setNotificatioId,
  setLeadPageRefresh,
} from "../../../redux/slice/authSlice";
import { createAuditLogs } from "../../../api/providerApi/providerApi";

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

const formatDate = (dateString) => {
  const date = new Date(dateString);
  const options = { year: "numeric", month: "long", day: "numeric" };
  return date.toLocaleDateString("en-US", options);
};

const headCells = [
  {
    id: "created_at",
    numeric: true,
    disablePadding: true,
    label: "Date Submitted",
  },
  {
    id: "name",
    numeric: true,
    disablePadding: false,
    label: "Patient Name",
  },
  {
    id: "age",
    numeric: true,
    disablePadding: false,
    label: "Age",
  },
  {
    id: "phone_number ",
    numeric: true,
    disablePadding: false,
    label: "Phone",
  },
  {
    id: "bvdqScores",
    numeric: true,
    disablePadding: false,
    label: "BVDQ™ Score",
  },
  // {
  //   id: "country_of_residence",
  //   numeric: true,
  //   disablePadding: false,
  //   label: "Country",
  // },
   {
    id: "state",
    numeric: true,
    disablePadding: false,
    label: "State",
  },
  {
    id: "city",
    numeric: true,
    disablePadding: false,
    label: "City",
  },
  {
    id: "status",
    numeric: true,
    disablePadding: false,
    label: "Status",
  },
  {
    id: "actions",
    numeric: true,
    disablePadding: false,
    label: "Actions",
  },
];

function EnhancedTableHead(props) {
  const {
    onSelectAllClick,
    order,
    orderBy,
    numSelected,
    rowCount,
    onRequestSort,
  } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        <TableCell padding="checkbox">
          <Checkbox
            color="primary"
            indeterminate={numSelected > 0 && numSelected < rowCount}
            checked={rowCount > 0 && numSelected === rowCount}
            onChange={onSelectAllClick}
            inputProps={{
              "aria-label": "select all desserts",
            }}
          />
        </TableCell>
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            // align={headCell.numeric ? 'right' : 'left'}
            padding={headCell.disablePadding ? "none" : "normal"}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : "asc"}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <Box component="span" sx={visuallyHidden}>
                  {order === "desc" ? "sorted descending" : "sorted ascending"}
                </Box>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(["asc", "desc"]).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

function EnhancedTableToolbar(props) {
  const { numSelected } = props;

  return <></>;
}

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
};

export const TableList = ({ activeTab, refresh, search, leadRows }) => {
  const userRole = useSelector((state) => state.auth.role);
  const { encryptData, decryptData } = useEncryption();
  const { id } = useParams();
  const toastOptions = useToast();
  const headers = useHeaders();
  const [loading, setLoading] = useOutletContext();
  const [order, setOrder] = React.useState("desc");
  const [orderBy, setOrderBy] = React.useState("created_at");
  const [selected, setSelected] = React.useState([]);
  const [page, setPage] = React.useState(0);
  const [dense, setDense] = React.useState(false);
  const [rowsPerPage, setRowsPerPage] = React.useState(100);
  const [rows, setRows] = useState([]);
  const [totalLeads, setTotalLeads] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [selectedLead, setSelectedLead] = useState(null);
  const [selectedLeadId, setSelectedLeadId] = useState(null);
  const [updatedNotes, setUpdatedNotes] = React.useState(false);
  const [openDialouge, setopenDialouge] = useState(false);
  const [open, setOpen] = useState(false);
  const [openPatientId, setOpenPatientId] = useState(false);
  const dispatch = useDispatch();
  const decryptedId = decryptData(decodeURIComponent(id));
  const dialogRef = useRef(null);
  const { notificationId } = useSelector(selectAuth);

  const handleCopy = () => {
    if (selectedLead?.patientId) {
      navigator.clipboard.writeText(selectedLead?.patientId);
      toast.success("Patient ID copied to clipboard!");
    }
  };

  const getclassName = (status) => {
    switch (status) {
      case "New Lead":
        return "newlead";
      case "Scheduled For Contact":
        return "scheduledcontact";
      case "Contact Attempted":
        return "contacted";
      case "Ready To Schedule":
        return "readytoSchedule";
      case "In Process":
        return "inprogress";
      case "Scheduled":
        return "scheduled";
      case "UnScheduled":
        return "unscheduled";
      case "Archived":
        return "archived";
      default:
        return "";
    }
  };

  useEffect(() => {
    fetchData();
  }, [page, rowsPerPage, order, orderBy, activeTab, refresh, search]);

  const fetchData = async () => {
    try {
      setLoading(true);
      const response = await getAllLeadsApi(
        decryptedId,
        page,
        rowsPerPage,
        orderBy,
        order,
        activeTab,
        search
      );
      const decryptedData = decryptData(response?.data?.data);
      const leadIds = decryptedData.leads.map(lead => lead._id);
      leadRows(leadIds)
      setRows(decryptedData?.leads);
      setTotalLeads(decryptedData?.totalLeads);
      setTotalPages(decryptedData?.totalPages);
      setLoading(false);

      if (notificationId != "") {
        const lead = decryptedData.leads.find(
          (lead) => lead._id === notificationId
        );
        setSelectedLead(lead);
        setSelectedLeadId(lead._id);
        setopenDialouge(true);
      }
    } catch (error) {
      setLoading(false);
      console.error("Error fetching data:", error);
    }
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelected = rows.map((row) => row._id);
      setSelected(newSelected);
      return;
    }
    dispatch(setSelectedId(selected));
    setSelected([]);
  };

  const handleClick = (event, id) => {
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }
    dispatch(setSelectedId(newSelected));
    setSelected(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleChangeDense = (event) => {
    setDense(event.target.checked);
  };

  const isSelected = (id) => selected.indexOf(id) !== -1;

  const emptyRows = rows?.length == 0;

  // const emptyRows =
  //     page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;

  // const visibleRows = React.useMemo(
  //     () =>
  //         stableSort(rows, getComparator(order, orderBy)).slice(
  //             page * rowsPerPage,
  //             page * rowsPerPage + rowsPerPage,
  //         ),
  //     [order, orderBy, page, rowsPerPage, totalPages],
  // );

  const [age, setAge] = React.useState("");
  const handleChange = (event) => {
    setAge(event.target.value);
  };

  const handleStatusChange = async (event, row) => {
    const newStatus = event.target.value;
    const leadId = row._id;
    const previousRows = [...rows];

    if (activeTab === "All Leads") {
      setRows((prevData) =>
        prevData.map((item) =>
          item._id === leadId ? { ...item, status: newStatus } : item
        )
      );

      try {
        const payload = {
          status: newStatus,
        };
        const data = encryptData(payload);
        const response = await updateLeadStatusApi(leadId, data, headers);
        let obj = {
          event: "Doctor has updated the lead status.",
        };
        await createAuditLogs({ data: encryptData(obj) }, headers);
        toast.success(response.data.message, toastOptions);
      } catch (error) {
        setRows(previousRows);
        toast.error(error?.response?.data?.message, toastOptions);
      }
    } else {
      setRows((prevData) => prevData.filter((item) => item._id !== leadId));

      try {
        const payload = {
          status: newStatus,
        };
        const data = encryptData(payload);
        const response = await updateLeadStatusApi(leadId, data, headers);
        let obj = {
          event: "Doctor has updated the lead status.",
        };
        await createAuditLogs({ data: encryptData(obj) }, headers);
        toast.success(response.data.message, toastOptions);
      } catch (error) {
        setRows(previousRows);
        toast.error(error?.response?.data?.message, toastOptions);
      }
    }
  };

  const handleStatusUpdate = async (event) => {
    const newStatus = event.target.value;
    const leadId = selectedLead._id;
    const previousLead = { ...selectedLead };

    setSelectedLead((prevLead) => ({
      ...prevLead,
      status: newStatus,
    }));

    try {
      const payload = {
        status: newStatus,
      };
      const data = encryptData(payload);
      const response = await updateLeadStatusApi(leadId, data, headers);
      let obj = {
        event: "Doctor has updated the lead status.",
      };
      await createAuditLogs({ data: encryptData(obj) }, headers);
      toast.success(response.data.message, toastOptions);
    } catch (error) {
      setSelectedLead(previousLead);
      toast.error(error?.response?.data?.message, toastOptions);
    }
  };

  const handleClickOpen = (leadId) => {
    setSelectedLeadId(leadId);
    setOpen(true);
  };
  const handleClose = () => {
    if (!selectedLead) {
      setSelectedLeadId(null);
    }
    setUpdatedNotes((prev) => !prev);
    setOpen(false);
  };

  const handleClickOpenedLeadModal = (leadId) => {
    const lead = rows.find((lead) => lead._id === leadId);
    // console.log("selected lead", lead);
    setSelectedLead(lead);
    setSelectedLeadId(lead._id);
    setopenDialouge(true);
  };

  const handleClickOpenPatientId = (leadId) => {
    const lead = rows.find((lead) => lead._id === leadId);
    setSelectedLead(lead);
    setOpenPatientId(true);
  };

  const handleClickPatientIdClose = () => {
    setSelectedLead(null);
    setOpenPatientId(false);
  };

  const handleClosedLeadModal = () => {
    setopenDialouge(false);
    setSelectedLead(null);
    setSelectedLeadId(null);
    dispatch(setLeadPageRefresh(!refresh));
    dispatch(setNotificatioId(""));
  };

  const [profilePic, setProfilePic] = useState(null); // Initialize with null to handle no image case

  const handleImageChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setProfilePic(reader.result); // Set the image URL to the state
      };
      reader.readAsDataURL(file); // Convert the file to a data URL
    }
  };

  const triggerFileUpload = () => {
    document.getElementById("file-upload").click();
  };

  const sliderBarRef = useRef(null);
  const pointerRef = useRef(null);

  const topSymptoms = getTopSymptoms(
    decryptData(selectedLead?.formsortResponse)?.answers
  );

  const answers = decryptData(selectedLead?.formsortResponse)?.answers;
  // console.log("answers", answers);

  const topSymptomNames = topSymptoms.map((symptom) => symptom.name);

  const symptomKeyMap = {
    Dizziness: "dizziness",
    Nausea: "nausea",
    Anxiety: "anxiety",
    Headaches: "headache",
    "Neck Pain": "neck_pain",
    "Unsteady with Walking": "balance_issues",
    "Sensitivity to Light": "light_sensitivity",
    "Reading Difficulty": "reading_challenges",
    "Sound Sensitivity": "sound_sensitivity",
  };

  const score =
    answers?.above13age_bvdq_scores ??
    answers?.["4to8age_bvdq_scores"] ??
    answers?.["9to13age_bvdq_scores"] ??
    "--";

  const adultMaxScore = 75;
  const preTeenMaxScore = 48;
  const childMaxScore = 13;

  const adultPointerPosition =
    score !== "--" && score >= 0 && score <= adultMaxScore
      ? (score / adultMaxScore) * 100
      : 0;

  const preteenPointerPosition =
    score !== "--" && score >= 0 && score <= preTeenMaxScore
      ? (score / preTeenMaxScore) * 100
      : 0;

  const childPointerPosition =
    score !== "--" && score >= 0 && score <= childMaxScore
      ? (score / childMaxScore) * 100
      : 0;

  return (
    <div className="tableDesigned">
      <Box>
        <Paper>
          <EnhancedTableToolbar numSelected={selected.length} />
          <TableContainer>
            <Table>
              <EnhancedTableHead
                numSelected={selected.length}
                order={order}
                orderBy={orderBy}
                onSelectAllClick={handleSelectAllClick}
                onRequestSort={handleRequestSort}
                rowCount={totalLeads}
              />
              <TableBody>
                {rows.map((row, index) => {
                  const isItemSelected = isSelected(row._id);
                  const labelId = `enhanced-table-checkbox-${index}`;

                  return (
                    <TableRow
                      hover
                      role="checkbox"
                      aria-checked={isItemSelected}
                      tabIndex={-1}
                      key={row._id}
                      selected={isItemSelected}
                      sx={{ cursor: "pointer" }}
                    >
                      <TableCell padding="checkbox">
                        <Checkbox
                          onClick={(event) => handleClick(event, row._id)}
                          color="primary"
                          checked={isItemSelected}
                          inputProps={{
                            "aria-labelledby": labelId,
                          }}
                        />
                      </TableCell>
                      <TableCell
                        component="th"
                        id={labelId}
                        scope="row"
                        padding="none"
                        onClick={() => handleClickOpenedLeadModal(row?._id)}
                      >
                        {convertToUSFormat(row?.created_at)}
                      </TableCell>
                      <TableCell
                        onClick={() => handleClickOpenedLeadModal(row?._id)}
                      >
                        {/* {decryptData(row?.formsortResponse)?.answers?.name ??
                          "--"} */}
                       {decryptData(row?.formsortResponse)?.answers?.Enter_firstname ||
                            decryptData(row?.formsortResponse)?.answers?.Enter_firstname2 ||
                            decryptData(row?.formsortResponse)?.answers?.name ||
                            ''}{" "}
                             {decryptData(row?.formsortResponse)?.answers?.Enter_lastname ||
                            decryptData(row?.formsortResponse)?.answers?.Enter_lastname ||
                            decryptData(row?.formsortResponse)?.answers?.Enter_lastname ||
                            ''}
                      </TableCell>
                      <TableCell
                        onClick={() => handleClickOpenedLeadModal(row?._id)}
                      >
                        {decryptData(row?.formsortResponse)?.answers?.age ??
                          "--"}
                      </TableCell>
                      <TableCell
                        onClick={() => handleClickOpenedLeadModal(row?._id)}
                      >
                        {decryptData(row?.formsortResponse)?.answers
                          ?.phone_number ?? "--"}
                      </TableCell>
                      <TableCell
                        onClick={() => handleClickOpenedLeadModal(row?._id)}
                      >
                        {row?.bvdqScores ?? "--"}
                      </TableCell>
                      {/* <TableCell
                        onClick={() => handleClickOpenedLeadModal(row?._id)}
                      >
                        {decryptData(row?.formsortResponse)?.answers
                          ?.country_of_residence || decryptData(row?.formsortResponse)?.answers
                            ?.country_of_residence_ || "--"}
                      </TableCell> */}
                       <TableCell
                                                onClick={() => handleClickOpenedLeadModal(row?._id)}
                                              >
                                                {decryptData(row?.formsortResponse)?.answers
                                                  ?.state || decryptData(row?.formsortResponse)?.answers
                                                    ?.state || "--"}
                                              </TableCell>
                                              <TableCell
                                                onClick={() => handleClickOpenedLeadModal(row?._id)}
                                              >
                                                {decryptData(row?.formsortResponse)?.answers
                                                  ?.city || decryptData(row?.formsortResponse)?.answers
                                                    ?.city || "--"}
                                              </TableCell>
                      <TableCell>
                        <FormControl sx={{ m: 1, minWidth: 120 }}>
                          <Select
                            className={`statelabeld ${getclassName(
                              row?.status
                            )}`}
                            value={row?.status}
                            onChange={(event) => handleStatusChange(event, row)}
                            displayEmpty
                            inputProps={{ "aria-label": "Without label" }}
                            size="small"
                            // disabled={userRole === "staff"}
                          >
                            <MenuItem value="New Lead">New Lead</MenuItem>
                            <MenuItem value="Scheduled For Contact">
                              Scheduled For Contact
                            </MenuItem>
                            <MenuItem value="Contact Attempted">
                              Contact Attempted
                            </MenuItem>
                            <MenuItem value="Ready To Schedule">
                              Ready To Schedule
                            </MenuItem>
                            <MenuItem value="In Process">In Process</MenuItem>
                            <MenuItem value="Scheduled">Scheduled</MenuItem>
                            <MenuItem value="UnScheduled">Unscheduled</MenuItem>
                            <MenuItem value="Archived">Archived</MenuItem>
                            
                          </Select>
                        </FormControl>
                      </TableCell>
                      <TableCell>
                        <div className="btn-groups">
                          <button
                            onClick={() => handleClickOpenedLeadModal(row?._id)}
                            className="actionbuttons"
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                            >
                              <path
                                d="M20.4908 11.1432C20.8361 11.6696 20.8361 12.3304 20.4908 12.8568C19.4032 14.5146 16.5729 18 11.9999 18C7.4269 18 4.5966 14.5146 3.50898 12.8568C3.16367 12.3304 3.16367 11.6696 3.50898 11.1432C4.5966 9.48535 7.4269 6 11.9999 6C16.5729 6 19.4032 9.48535 20.4908 11.1432Z"
                                stroke="#35353A"
                                strokeWidth="1.25"
                                strokeLinecap="round"
                              />
                              <path
                                d="M15 12C15 13.6569 13.6568 15 12 15C10.3431 15 9 13.6569 9 12C9 10.3431 10.3431 9 12 9C13.6568 9 15 10.3431 15 12Z"
                                stroke="#35353A"
                                strokeWidth="1.25"
                                strokeLinecap="round"
                              />
                            </svg>
                          </button>
                          {(userRole === "doctor" ||
                            userRole === "provider" ||
                            userRole === "location" ||
                            userRole === "staff" ) && (
                              <button
                                onClick={() => handleClickOpen(row?._id)}
                                className="actionbuttons"
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="24"
                                  height="24"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                >
                                  <path
                                    d="M18 10V9.82843C18 9.29799 17.7893 8.78929 17.4142 8.41421L13.5858 4.58579C13.2107 4.21071 12.702 4 12.1716 4H12M18 10V18C18 19.1046 17.1046 20 16 20H13M18 10H14C12.8954 10 12 9.10457 12 8V4M12 4H8C6.89543 4 6 4.89543 6 6V13M6 20V17.5M6 20V22.5M6 20H3.5M6 20H8.5"
                                    stroke="#35353A"
                                    strokeWidth="1.25"
                                    strokeLinecap="round"
                                  />
                                </svg>
                              </button>
                            )}
                          <button
                            onClick={() => handleClickOpenPatientId(row?._id)}
                            className="actionbuttons"
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                            >
                              <path
                                d="M16.5 3.5H18.5C19.6046 3.5 20.5 4.39543 20.5 5.5V7.5M16.5 20.5H18.5C19.6046 20.5 20.5 19.6046 20.5 18.5V16.5M7.5 3.5H5.5C4.39543 3.5 3.5 4.39543 3.5 5.5V7.5M7.5 20.5H5.5C4.39543 20.5 3.5 19.6046 3.5 18.5V16.5M7.5 17.5H9.5C10.0523 17.5 10.5 17.0523 10.5 16.5V14.5C10.5 13.9477 10.0523 13.5 9.5 13.5H7.5C6.94772 13.5 6.5 13.9477 6.5 14.5V16.5C6.5 17.0523 6.94772 17.5 7.5 17.5ZM14.5 14C14.5 14.2761 14.2761 14.5 14 14.5C13.7239 14.5 13.5 14.2761 13.5 14C13.5 13.7239 13.7239 13.5 14 13.5C14.2761 13.5 14.5 13.7239 14.5 14ZM14.5 17C14.5 17.2761 14.2761 17.5 14 17.5C13.7239 17.5 13.5 17.2761 13.5 17C13.5 16.7239 13.7239 16.5 14 16.5C14.2761 16.5 14.5 16.7239 14.5 17ZM17.5 17C17.5 17.2761 17.2761 17.5 17 17.5C16.7239 17.5 16.5 17.2761 16.5 17C16.5 16.7239 16.7239 16.5 17 16.5C17.2761 16.5 17.5 16.7239 17.5 17ZM17.5 14C17.5 14.2761 17.2761 14.5 17 14.5C16.7239 14.5 16.5 14.2761 16.5 14C16.5 13.7239 16.7239 13.5 17 13.5C17.2761 13.5 17.5 13.7239 17.5 14ZM7.5 10.5H9.5C10.0523 10.5 10.5 10.0523 10.5 9.5V7.5C10.5 6.94772 10.0523 6.5 9.5 6.5H7.5C6.94772 6.5 6.5 6.94772 6.5 7.5V9.5C6.5 10.0523 6.94772 10.5 7.5 10.5ZM14.5 10.5H16.5C17.0523 10.5 17.5 10.0523 17.5 9.5V7.5C17.5 6.94772 17.0523 6.5 16.5 6.5H14.5C13.9477 6.5 13.5 6.94772 13.5 7.5V9.5C13.5 10.0523 13.9477 10.5 14.5 10.5Z"
                                stroke="#35353A"
                                strokeWidth="1.25"
                                strokeLinecap="round"
                              />
                            </svg>
                          </button>
                        </div>
                      </TableCell>
                    </TableRow>
                  );
                })}
                {emptyRows && (
                  <TableRow
                    style={{
                      height: (dense ? 33 : 53) * emptyRows,
                    }}
                  >
                    <TableCell colSpan={9} className="norecord">
                      No Record Found
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={totalLeads}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Paper>
      </Box>
      <PatientIdModal
        openPatientId={openPatientId}
        handleClose={handleClickPatientIdClose}
        lead={selectedLead}
      />
      <AddNotesModal
        open={open}
        handleClose={handleClose}
        leadId={selectedLeadId}
      />

      <Dialog
        onClose={handleClosedLeadModal}
        aria-labelledby="customized-dialog-title"
        open={openDialouge}
        className="weighty"
      >
        <div className="d-flex align-items-center justify-content-between">
          <DialogTitle id="customized-dialog-title">
            Patient Profile
          </DialogTitle>
          <div className="d-flex align-items-center">
            <IconButton aria-label="close" onClick={handleClosedLeadModal}>
              <CloseIcon />
            </IconButton>
          </div>
        </div>

        <DialogContent dividers className="modelcontentSection">
          <div className="row" ref={dialogRef}>
            <div className="col-lg-4 col-sm-12 border-side">
              <ContactInfoForm
                selectedLead={selectedLead}
                getclassName={getclassName}
                handleStatusUpdate={handleStatusUpdate}
                handleCopy={handleCopy}
              />
              <Notes
                leadId={selectedLead?._id}
                setOpen={setOpen}
                updatedNotes={updatedNotes}
              />
            </div>
            <div className="col-lg-8 col-sm-12 ">
              <div className="row mb-3">
                <div className="col-lg-3 col-sm-12">
                  <div className="blockdig new-blockdig-controller">
                    <h6>
                      {getAgeCategory(
                        decryptData(selectedLead?.formsortResponse)?.answers
                          ?.age
                      )}
                    </h6>
                    <p>{formatDate(selectedLead?.created_at)}</p>
                  </div>
                </div>
                <div className="col-lg-5 col-sm-12">
                  <div className="blockdig new-blockdig-controller">
                    <h6>
                      BVDQ™ Score of <span className="blued">{score}</span>
                    </h6>
                    {answers?.above13age_bvdq_scores !== undefined &&
                    answers?.above13age_bvdq_scores !== null ? (
                      // <div className="custom-slider-container">
                      //   <div className="custom-slider-bar" ref={sliderBarRef}>
                      //     <div
                      //       className="custom-slider-segment custom-unlikely"
                      //       style={{
                      //         left: 0,
                      //         width: `calc((14 / 75) * 100%)`,
                      //       }}
                      //     >
                      //       <div className="custom-slider-label mt-5 custom-label-unlikely">
                      //         Unlikely
                      //         <br />
                      //         <span>0-14</span>
                      //       </div>
                      //     </div>
                      //     <div
                      //       className="custom-slider-segment custom-mild"
                      //       style={{
                      //         left: `calc((14 / 75) * 100%)`,
                      //         width: `calc((10 / 75) * 100%)`,
                      //       }}
                      //     >
                      //       <div className="custom-slider-label mt-5 custom-label-mild">
                      //         Mild
                      //         <br />
                      //         <span>15-24</span>
                      //       </div>
                      //     </div>
                      //     <div
                      //       className="custom-slider-segment custom-moderate"
                      //       style={{
                      //         left: `calc((24 / 75) * 100%)`,
                      //         width: `calc((15 / 75) * 100%)`,
                      //       }}
                      //     >
                      //       <div className="custom-slider-label mt-5 custom-label-moderate">
                      //         Moderate
                      //         <br />
                      //         <span>25-39</span>
                      //       </div>
                      //     </div>
                      //     <div
                      //       className="custom-slider-segment custom-severe"
                      //       style={{
                      //         left: `calc((39 / 75) * 100%)`,
                      //         width: `calc((36 / 75) * 100%)`,
                      //       }}
                      //     >
                      //       <div className="custom-slider-label mt-5 custom-label-severe">
                      //         Severe
                      //         <br />
                      //         <span>40-75</span>
                      //       </div>
                      //     </div>
                      //     <div
                      //       className="custom-slider-pointer"
                      //       ref={pointerRef}
                      //       style={{
                      //         left: `calc(${adultPointerPosition}% - 10px)`,
                      //       }}
                      //     ></div>
                      //   </div>
                      // </div>
                      <div className="custom-slider-container">
                        <div className="custom-slider-bar" ref={sliderBarRef}>
                          <div
                            className="custom-slider-segment custom-unlikely"
                            style={{
                              left: 0,
                              width: `calc((14 / 75) * 100%)`,
                            }}
                          >
                            <div className="custom-slider-label mt-5 custom-label-unlikely">
                              Unlikely
                              <br />
                              <span>0-14</span>
                            </div>
                          </div>
                          <div
                            className="custom-slider-segment custom-mild"
                            style={{
                              left: `calc((14 / 75) * 100%)`,
                              width: `calc((16 / 75) * 100%)`,
                            }}
                          >
                            <div className="custom-slider-label mt-5 custom-label-mild">
                              Moderate
                              <br />
                              <span>15-30</span>
                            </div>
                          </div>
                          <div
                            className="custom-slider-segment custom-moderate"
                            style={{
                              left: `calc((30 / 75) * 100%)`,
                              width: `calc((15 / 75) * 100%)`,
                            }}
                          >
                            <div className="custom-slider-label mt-5 custom-label-moderate">
                              High
                              <br />
                              <span>31-45</span>
                            </div>
                          </div>
                          <div
                            className="custom-slider-segment custom-severe"
                            style={{
                              left: `calc((45 / 75) * 100%)`,
                              width: `calc((30 / 75) * 100%)`,
                            }}
                          >
                            <div className="custom-slider-label mt-5 custom-label-severe">
                              Severe
                              <br />
                              <span>46-75</span>
                            </div>
                          </div>
                          <div
                            className="custom-slider-pointer"
                            ref={pointerRef}
                            style={{
                              left: `calc(${adultPointerPosition}% - 10px)`,
                            }}
                          ></div>
                        </div>
                      </div>
                    ) : answers?.["4to8age_bvdq_scores"] !== undefined &&
                    answers?.["4to8age_bvdq_scores"] !== null ? (
                      // <div className="custom-slider-container">
                      //   <div className="custom-slider-bar" ref={sliderBarRef}>
                      //     <div
                      //       className="custom-slider-segment custom-unlikely"
                      //       style={{
                      //         left: 0,
                      //         width: `calc((3 / 13) * 100%)`,
                      //       }}
                      //     >
                      //       <div className="custom-slider-label mt-5 custom-label-unlikely">
                      //         Unlikely
                      //         <br />
                      //         <span>0-3</span>
                      //       </div>
                      //     </div>
                      //     <div
                      //       className="custom-slider-segment custom-mild"
                      //       style={{
                      //         left: `calc((3 / 13) * 100%)`,
                      //         width: `calc((4 / 13) * 100%)`,
                      //       }}
                      //     >
                      //       <div className="custom-slider-label mt-5 custom-label-mild">
                      //         Mild
                      //         <br />
                      //         <span>4-7</span>
                      //       </div>
                      //     </div>
                      //     <div
                      //       className="custom-slider-segment custom-moderate"
                      //       style={{
                      //         left: `calc((7 / 13) * 100%)`,
                      //         width: `calc((3 / 13) * 100%)`,
                      //       }}
                      //     >
                      //       <div className="custom-slider-label mt-5 custom-label-moderate">
                      //         Moderate
                      //         <br />
                      //         <span>8-10</span>
                      //       </div>
                      //     </div>
                      //     <div
                      //       className="custom-slider-segment custom-severe"
                      //       style={{
                      //         left: `calc((10 / 13) * 100%)`,
                      //         width: `calc((3 / 13) * 100%)`,
                      //       }}
                      //     >
                      //       <div className="custom-slider-label mt-5 custom-label-severe">
                      //         Severe
                      //         <br />
                      //         <span>11-13</span>
                      //       </div>
                      //     </div>
                      //     <div
                      //       className="custom-slider-pointer"
                      //       ref={pointerRef}
                      //       style={{
                      //         left: `calc(${childPointerPosition}% - 10px)`,
                      //       }}
                      //     ></div>
                      //   </div>
                      // </div>
                      <div className="custom-slider-container">
                        <div className="custom-slider-bar" ref={sliderBarRef}>
                          <div
                            className="custom-slider-segment custom-unlikely"
                            style={{
                              left: 0,
                              width: `calc((3 / 13) * 100%)`,
                            }}
                          >
                            <div className="custom-slider-label mt-5 custom-label-unlikely">
                              Unlikely
                              <br />
                              <span>0-3</span>
                            </div>
                          </div>
                          <div
                            className="custom-slider-segment custom-mild"
                            style={{
                              left: `calc((3 / 13) * 100%)`,
                              width: `calc((4 / 13) * 100%)`,
                            }}
                          >
                            <div className="custom-slider-label mt-5 custom-label-mild">
                              Moderate
                              <br />
                              <span>4-7</span>
                            </div>
                          </div>
                          <div
                            className="custom-slider-segment custom-moderate"
                            style={{
                              left: `calc((7 / 13) * 100%)`,
                              width: `calc((3 / 13) * 100%)`,
                            }}
                          >
                            <div className="custom-slider-label mt-5 custom-label-moderate">
                              High
                              <br />
                              <span>8-10</span>
                            </div>
                          </div>
                          <div
                            className="custom-slider-segment custom-severe"
                            style={{
                              left: `calc((10 / 13) * 100%)`,
                              width: `calc((3 / 13) * 100%)`,
                            }}
                          >
                            <div className="custom-slider-label mt-5 custom-label-severe">
                              Severe
                              <br />
                              <span>11-13</span>
                            </div>
                          </div>
                          <div
                            className="custom-slider-pointer"
                            ref={pointerRef}
                            style={{
                              left: `calc(${childPointerPosition}% - 10px)`,
                            }}
                          ></div>
                        </div>
                      </div>
                    ) : answers?.["9to13age_bvdq_scores"] !== undefined &&
                    answers?.["9to13age_bvdq_scores"] !== null ? (
                      // <div className="custom-slider-container">
                      //   <div className="custom-slider-bar" ref={sliderBarRef}>
                      //     <div
                      //       className="custom-slider-segment custom-unlikely"
                      //       style={{
                      //         left: 0,
                      //         width: `calc((9 / 48) * 100%)`,
                      //       }}
                      //     >
                      //       <div className="custom-slider-label mt-5 custom-label-unlikely">
                      //         Unlikely
                      //         <br />
                      //         <span>0-9</span>
                      //       </div>
                      //     </div>
                      //     <div
                      //       className="custom-slider-segment custom-mild"
                      //       style={{
                      //         left: `calc((9 / 48) * 100%)`,
                      //         width: `calc((6 / 48) * 100%)`,
                      //       }}
                      //     >
                      //       <div className="custom-slider- mt-5 custom-label-mild">
                      //         Mild
                      //         <br />
                      //         <span>10-15</span>
                      //       </div>
                      //     </div>
                      //     <div
                      //       className="custom-slider-segment custom-moderate"
                      //       style={{
                      //         left: `calc((15 / 48) * 100%)`,
                      //         width: `calc((10 / 48) * 100%)`,
                      //       }}
                      //     >
                      //       <div className="custom-slider-label mt-5 custom-label-moderate">
                      //         Moderate
                      //         <br />
                      //         <span>16-25</span>
                      //       </div>
                      //     </div>
                      //     <div
                      //       className="custom-slider-segment custom-severe"
                      //       style={{
                      //         left: `calc((25 / 48) * 100%)`,
                      //         width: `calc((23 / 48) * 100%)`,
                      //       }}
                      //     >
                      //       <div className="custom-slider-label mt-5 custom-label-severe">
                      //         Severe
                      //         <br />
                      //         <span>26-48</span>
                      //       </div>
                      //     </div>
                      //     <div
                      //       className="custom-slider-pointer"
                      //       ref={pointerRef}
                      //       style={{
                      //         left: `calc(${preteenPointerPosition}% - 10px)`,
                      //       }}
                      //     ></div>
                      //   </div>
                      // </div>
                      <div className="custom-slider-container">
                        <div className="custom-slider-bar" ref={sliderBarRef}>
                          <div
                            className="custom-slider-segment custom-unlikely"
                            style={{
                              left: 0,
                              width: `calc((9 / 48) * 100%)`,
                            }}
                          >
                            <div className="custom-slider-label mt-5 custom-label-unlikely">
                              Unlikely
                              <br />
                              <span>0-9</span>
                            </div>
                          </div>
                          <div
                            className="custom-slider-segment custom-mild"
                            style={{
                              left: `calc((9 / 48) * 100%)`,
                              width: `calc((10 / 48) * 100%)`,
                            }}
                          >
                            <div className="custom-slider-label mt-5 custom-label-mild">
                              Moderate
                              <br />
                              <span>10-19</span>
                            </div>
                          </div>
                          <div
                            className="custom-slider-segment custom-moderate"
                            style={{
                              left: `calc((19 / 48) * 100%)`,
                              width: `calc((10 / 48) * 100%)`,
                            }}
                          >
                            <div className="custom-slider-label mt-5 custom-label-moderate">
                              High
                              <br />
                              <span>20-29</span>
                            </div>
                          </div>
                          <div
                            className="custom-slider-segment custom-severe"
                            style={{
                              left: `calc((29 / 48) * 100%)`,
                              width: `calc((19 / 48) * 100%)`,
                            }}
                          >
                            <div className="custom-slider-label mt-5 custom-label-severe">
                              Severe
                              <br />
                              <span>30-48</span>
                            </div>
                          </div>
                          <div
                            className="custom-slider-pointer"
                            ref={pointerRef}
                            style={{
                              left: `calc(${preteenPointerPosition}% - 10px)`,
                            }}
                          ></div>
                        </div>
                      </div>
                    ) : (
                      <div>No Scale available</div>
                    )}
                  </div>
                </div>

                <div className="col-lg-4 col-sm-12">
                  <div className="blockdig new-blockdig-controller">
                    <h6>
                      SSI Score of{" "}
                      <span className="reds">
                        {
                          decryptData(selectedLead?.formsortResponse)?.answers
                            ?.ssi_scores
                        }
                      </span>
                    </h6>
                    <p>Top 3 Symptoms by Severity</p>
                    <div className="symptonlist">
                      {topSymptoms.map((symptom, index) => (
                        <div key={index} className="chip">
                          {symptom.name}: {symptom.value}
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-lg-8 col-sm-12">
                  <div className="scoreborad greybackbox">
                    <h5>
                      Symptom Frequency (BVDQ Score:{" "}
                      {answers?.above13age_bvdq_scores ??
                        answers?.["4to8age_bvdq_scores"] ??
                        answers?.["9to13age_bvdq_scores"] ??
                        "--"}
                      )
                    </h5>

                    {answers?.above13age_bvdq_scores  !== undefined &&
                    answers?.above13age_bvdq_scores  !== null ? (
                      <div className="questionblockw">
                        {above13AgeQuestionsBVDQ.map((item, index) => (
                          <div
                            key={index}
                            className={`d-flex align-items-center justify-content-between ${answers?.[item.key] === "Always"
                              ? "hightedquestion"
                              : ""
                              }`}
                          >
                            {item.question} <span className="question"></span>
                            <span className="reason">
                              {answers?.[item.key]}
                            </span>
                          </div>
                        ))}
                      </div>
                    ) : answers?.["4to8age_bvdq_scores"] !== undefined &&
                    answers?.["4to8age_bvdq_scores"] !== null ? (
                      <div className="questionblockw">
                        {age4to8QuestionsBVDQ.map((item, index) => (
                          <div
                            key={index}
                            className={`d-flex align-items-center justify-content-between ${answers?.[item.key] === "Yes"
                              ? "hightedquestion"
                              : ""
                              }`}
                          >
                            {item.question} <span className="question"></span>
                            <span className="reason">
                              {answers?.[item.key]}
                            </span>
                          </div>
                        ))}
                      </div>
                    ) : answers?.["9to13age_bvdq_scores"] !== undefined &&
                    answers?.["9to13age_bvdq_scores"] !== null ? (
                      <div className="questionblockw">
                        {age9to13QuestionsBVDQ.map((item, index) => (
                          <div
                            key={index}
                            className={`d-flex align-items-center justify-content-between ${answers?.[item.key] === "Always"
                              ? "hightedquestion"
                              : ""
                              }`}
                          >
                            {item.question} <span className="question"></span>
                            <span className="reason">
                              {answers?.[item.key]}
                            </span>
                          </div>
                        ))}
                      </div>
                    ) : (
                      <div>No questions available</div>
                    )}
                  </div>

                  <div className="greybackbox">
                    <h5>Additional Comments</h5>
                    <p className="eplippsewrap-full">
                      {answers?.comment_section_optional || answers?.comment_section_optional_youth
                        ? <>
                          {answers?.comment_section_optional && (
                            <div>{answers.comment_section_optional}</div>
                          )}
                          {answers?.comment_section_optional_youth && (
                            <div>{answers.comment_section_optional_youth}</div>
                          )}
                        </>
                        : "No Comments Available"}
                    </p>
                  </div>
                </div>
                <div className="col-lg-4 col-sm-12">
                  <div className="greybackbox">
                    <h5>
                      Level of Discomfort (SSI:{" "}
                      {
                        decryptData(selectedLead?.formsortResponse)?.answers
                          ?.ssi_scores
                      }
                      )
                    </h5>
                    {Object.keys(symptomKeyMap).map((displayName) => {
                      const answerKey = symptomKeyMap[displayName];
                      if (answers && answers[answerKey] !== undefined) {
                        const isTopSymptom =
                          topSymptomNames.includes(displayName);
                        return (
                          <div
                            key={answerKey}
                            className={`smallitems d-flex align-items-center justify-content-between ${isTopSymptom ? "highlighted" : ""
                              }`}
                          >
                            <span>{displayName}:</span>
                            <span>{answers[answerKey]}</span>
                          </div>
                        );
                      }

                      return null;
                    })}
                  </div>
                  <div className="greybackbox">
                    <h5>Health History</h5>
                    {answers?.above13age_bvdq_scores !== undefined &&
                    answers?.above13age_bvdq_scores !== null ? (
                      <>
                        {above13AgeQuestionsHistory.map((item, index) =>
                          answers?.[item.key] == "Yes" ? (
                            <strong key={index}>
                              <div className="d-flex align-items-center font-small justify-content-between">
                                <span className="nowrap-custom">
                                  {item.question}
                                </span>
                                <span>{answers?.[item.key]}</span>
                              </div>
                            </strong>
                          ) : (
                            <div
                              key={index}
                              className="d-flex align-items-center font-small justify-content-between"
                            >
                              <span className="nowrap-custom">
                                {item.question}
                              </span>
                              <span>{answers?.[item.key]}</span>
                            </div>
                          )
                        )}
                      </>
                    ) : answers?.["4to8age_bvdq_scores"] !== undefined &&
                    answers?.["4to8age_bvdq_scores"] !== null ? (
                      <>
                        {age4to8QuestionsHistory.map((item, index) =>
                          answers?.[item.key] == "Yes" ? (
                            <strong key={index}>
                              <div className="d-flex align-items-center font-small justify-content-between">
                                <span className="nowrap-custom">
                                  {item.question}
                                </span>
                                <span>{answers?.[item.key]}</span>
                              </div>
                            </strong>
                          ) : (
                            <div
                              key={index}
                              className="d-flex align-items-center font-small justify-content-between"
                            >
                              <span className="nowrap-custom">
                                {item.question}
                              </span>
                              <span>{answers?.[item.key]}</span>
                            </div>
                          )
                        )}
                      </>
                    ) : answers?.["9to13age_bvdq_scores"] !== undefined &&
                    answers?.["9to13age_bvdq_scores"] !== null ? (
                      <>
                        {age9to13QuestionsHistory.map((item, index) =>
                          answers?.[item.key] == "Yes" ? (
                            <strong key={index}>
                              <div className="d-flex align-items-center font-small justify-content-between">
                                <span className="nowrap-custom">
                                  {item.question}
                                </span>
                                <span>{answers?.[item.key]}</span>
                              </div>
                            </strong>
                          ) : (
                            <div
                              key={index}
                              className="d-flex align-items-center font-small justify-content-between"
                            >
                              <span className="nowrap-custom">
                                {item.question}
                              </span>
                              <span>{answers?.[item.key]}</span>
                            </div>
                          )
                        )}
                      </>
                    ) : (
                      <div>No health history questions available</div>
                    )}
                  </div>
                  <div className="greybackbox">
                    <h5>Feedback on the BVDQ™ Assessment</h5>
                    <span>Discovered BVDQ™ Assessment via :</span>
                    <p className="eplippsewrap">
                      {answers?.find_bvdq_assessment
                        ? {
                          internet_search: "Internet Search",
                          facebook: "Facebook",
                          instagram: "Instagram",
                          tiktok: "TikTok",
                          forum_or_blog: "Forum or Blog",
                          referred_by_a_friend: "Referred by a Friend",
                          referred_by_a_professional: "Referred by a Professional",
                          youtube: "YouTube",
                        }[answers.find_bvdq_assessment] || answers.find_bvdq_assessment
                        : "No Feedback Available"}
                    </p>

                    <span>Additional Feedback :</span>
                    <p className="eplippsewrap">
                      {answers?.source_of_discovery
                        ? answers.source_of_discovery
                        : "No Feedback Available"}
                    </p>
                  </div>
                  {/* <div className="greybackbox">
                    <h5>Additional Comments</h5>
                    <p className="eplippsewrap">
                      {answers?.comment_section_optional || answers?.comment_section_optional_youth
                        ? <>
                          {answers?.comment_section_optional && (
                            <div>{answers.comment_section_optional}</div>
                          )}
                          {answers?.comment_section_optional_youth && (
                            <div>{answers.comment_section_optional_youth}</div>
                          )}
                        </>
                        : "No Comments Available"}
                    </p>
                  </div> */}
                </div>
              </div>

              <div className="row">
                <div className="col-lg-12 col-sm-12">
                  {/* <div className="greybackbox">
                    <h5>Initial Questions</h5>
                    <div className="row fs-16">
                      {initialQuestionsData.map((q, index) => (
                        <React.Fragment key={index}>
                          <div className="col-lg-6 col-sm-12">
                            {index + 1}. {q.question}
                          </div>
                          <div className="col-lg-6 col-sm-12">
                            {(Array.isArray(answers?.[q.variable])
                              ? answers[q.variable]
                              : [answers?.[q.variable]]
                            )
                              ?.filter(Boolean)
                              .map(
                                (value) =>
                                  q.options.find(
                                    (option) => option.value === value
                                  )?.label
                              )
                              .join(", ") || "N.A"}
                          </div>
                        </React.Fragment>
                      ))}
                    </div>
                  </div> */}
                </div>
              </div>
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
};
